import { useTranslation } from 'react-i18next';

export default function IntegrationGuide() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Shopify.components.IntegrationGuide',
  });

  return (
    <div className="rounded-md bg-gray-50 p-4">
      <h3 className="mb-4 text-xl font-bold">{t('title')}</h3>
      <p className="mb-4">{t('description')}</p>
      <div className="space-y-6">
        <div>
          <h3 className="text-md font-bold">{t('steps.step1.title')}</h3>
          <ul className="mt-2 list-disc space-y-1 pl-6">
            <li>{t('steps.step1.instructions.item1')}</li>
            <li>{t('steps.step1.instructions.item2')}</li>
            <li>{t('steps.step1.instructions.item3')}</li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold">{t('steps.step2.title')}</h3>
          <ul className="mt-2 list-disc space-y-1 pl-6">
            <li>{t('steps.step2.instructions.item1')}</li>
            <li>{t('steps.step2.instructions.item2')}</li>
            <li>{t('steps.step2.instructions.item3')}</li>
            <li>{t('steps.step2.instructions.item4')}</li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold">{t('steps.step3.title')}</h3>
          <ul className="mt-2 list-disc space-y-1 pl-6">
            <li>{t('steps.step3.instructions.item1')}</li>
            <li>{t('steps.step3.instructions.item2')}</li>
            <li>{t('steps.step3.instructions.item3')}</li>

            <ul className="mt-1 list-disc pl-6">
              <li>{t('steps.step3.instructions.item4')}</li>
              <li>{t('steps.step3.instructions.item5')}</li>
              <li>{t('steps.step3.instructions.item6')}</li>
              <li>{t('steps.step3.instructions.item7')}</li>
              <li>{t('steps.step3.instructions.item8')}</li>
              <li>{t('steps.step3.instructions.item9')}</li>
              <li>{t('steps.step3.instructions.item10')}</li>
              <li>{t('steps.step3.instructions.item11')}</li>
              <li>{t('steps.step3.instructions.item12')}</li>
            </ul>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold">{t('steps.step4.title')}</h3>
          <ul className="mt-2 list-disc space-y-1 pl-6">
            <li>{t('steps.step4.instructions.item1')}</li>
            <li>{t('steps.step4.instructions.item2')}</li>
            <li>{t('steps.step4.instructions.item3')}</li>
            <ul className="mt-1 list-disc pl-6">
              <li className="font-medium">
                {t('steps.step4.instructions.item4')}
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  );
}
